export default import.meta.ROLLDOWN_FILE_URL_ykX0QBwebHfvDi1hUiJzog